import { CLEAR_ORDER_CONFIRM_CART, SET_ORDER_CONFIRM_CART } from '../types';

export const setOrderConfirmCart = ({ cartData, orderData }) => ({
  type: SET_ORDER_CONFIRM_CART,
  payload: { cartData, orderData },
});

export const clearOrderConfirmCart = () => ({
  type: CLEAR_ORDER_CONFIRM_CART,
});

export const ORDER_CONFIRM_ACTIONS = {
  setOrderConfirmCart,
  clearOrderConfirmCart,
};
